import React from 'react';
import PropTypes from 'prop-types';
import {Link as ScrollLink} from 'react-scroll';


const PointerArrow = ({to, smooth, duration}) => {
    if (to) {
        return (
            <ScrollLink className="pointer-arrow" to={to} smooth={smooth} duration={duration} />
        );
    }
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a className="pointer-arrow" />;
};

PointerArrow.propTypes = {
    to: PropTypes.string.isRequired,
    smooth: PropTypes.bool,
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
};

PointerArrow.defaultProps = {
    smooth: true,
    duration: 500,
};

export default PointerArrow;



// WEBPACK FOOTER //
// ./src/components/PointerArrow.js